/**
 * Items that are always visible on the countertop and do not display SKU labels.
 * Used to filter visibility in overhead SKU modes.
 */
export const ALWAYS_VISIBLE_NO_SKU: Array<string> = ['POP-UP-OUTLET', 'UMBRELLA-CUTOUT'];
